import { GetStaticProps } from "next";
import { ComplainsFormularLayout } from "layouts/pages/ComplainsFormularLayout";

import { serverSideTranslations } from "utils/next/translations";

import { checkIsNotFound } from "../configs/unsupport-locale-routes";
import { UrlsConfig } from "../configs/urlsConfig";

export default function Candidate() {
    return <ComplainsFormularLayout />;
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
    if (checkIsNotFound(UrlsConfig.COMPLAINS_FORMULAR, locale)) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ["global"])),
            withHeader: false,
            withFooter: false,
            key: locale,
        },
    };
};
